import React, { useEffect, useState } from "react";
import { color, motion, useMotionValueEvent, useScroll } from "framer-motion";
import { initcards } from "../components/Showcase";
import { useNavigate } from "react-router-dom";

const BlogHeader = ({
  setSelectedBlog,
  setSelectedBlogContent,
  selectedblog,
  setactiveSection,
  activeSection,
  benefitsRef,
  abouref,
  timelineRef,
  isDarkMode,
}) => {
  const [arr, setarr] = useState([]);

  function settingArray() {
    let newarr = [...initcards];
    let val = null;
    // for (var x in newarr) newarr[x].title == selectedblog ? newarr.push(newarr.splice(x, 1)[0]) : 0;
    let array = newarr.filter((item, index) => {
      if (item.blogno != selectedblog) {
        return item;
      } else {
        val = item;
        // console.log(item)
        setSelectedBlogContent(item);
      }
    });

    if (val !== null) {
      array.push(val);
    }
    console.log(array);

    return array;
  }
  const [selectedcard, setSelectedCard] = useState(7);

  useEffect(() => {
    if (selectedblog !== "") {
      let xarry = settingArray();

      setarr(xarry);
    }
  }, [selectedblog]);
  function setCard(card, index) {
    setSelectedCard(card.id);
    let array = arr;
    array[index] = array[array.length - 1];
    array[array.length - 1] = card;
    setarr(array);
  }

  const [cardNumber, setCardNumber] = useState(7);

  function handleClick(id) {
    const buttonWrap = document.querySelector(".button-wrap");
    const clickedButtonElement = document.getElementById(id);

    if (clickedButtonElement?.classList[0] === "button") {
      clickedButtonElement?.classList.add("fade-out");
      setTimeout(() => {
        clickedButtonElement.classList.remove("fade-out");
        clickedButtonElement.remove();
        buttonWrap.appendChild(clickedButtonElement);
      }, 400);
    }
  }

  const navigate = useNavigate();

  return (
    <div
      style={{ backgroundColor: "transparent" }}
      className="Header_Container"
    >
      <div>
        <div
          style={{
            backgroundColor: "transparent",
            height: 220,
          }}
          className="Cards_header"
        >
          <div class="button-wrap">
            {arr.length !== 0 &&
              arr.map((item, index) => {
                return (
                  <div
                    id={item?.id}
                    onClick={() => {
                      // handleClick(item?.id);
                      setSelectedBlog(item?.blogno);
                      navigate(`/blog?${item?.blogno}`);
                    }}
                    // style={{ backgroundImage: `${require('../assets/Rectangle 20.png')}` }}

                    className={`button ${
                      item?.blogno === selectedblog ? "text-white" : ""
                    }`}
                  >
                    {item?.img != undefined && (
                      <img
                        style={{ zIndex: -10 }}
                        onClick={() => {
                          // handleClick(item?.id)
                        }}
                        className="absolute w-full"
                        src={
                          item?.blogno === selectedblog
                            ? require(`../assets/Rectangle Black.png`)
                            : require(`../assets/Rectangle White.png`)
                        }
                        alt="rectangle card"
                      />
                    )}

                    <span>{item?.id}</span>
                    {item?.title}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogHeader;
